import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

const INACTIVITY_MS = 10 * 60 * 1000; // 10 minutes

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  private timeoutId: any;
  private lastActivity = 0;

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) {}

  startWatching(): void {
    this.resetTimer();
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach(evt =>
      document.addEventListener(evt, () => this.onActivity())
    );
  }

  stopWatching(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private onActivity(): void {
    this.lastActivity = Date.now();
    this.resetTimer();
  }

  private resetTimer(): void {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => this.logout(), INACTIVITY_MS);
    });
  }

  private logout(): void {
    this.ngZone.run(() => {
      this.stopWatching();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
    });
  }
}
